import { GlobalFooter } from "@/patterns/global-footer/src/global-footer";

export const Footer = () => {
    return (
        <div>
            <GlobalFooter />
        </div>
    );
};

Footer.displayName = "Footer";
